<template>
  <div id="home">
    <div class="query-c">
      查询：
      <Input
        style="width: 200px"
        v-model="keyword"
        @input="changeInput()"
        search
        placeholder="请输入角色名称搜索查询内容"
      />
      <Select
        v-model="state"
        @on-change="changeInput"
        style="width:200px;margin-left: 20px;"
        placeholder="选择状态"
      >
        <Option v-for="item in types" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </div>
    <br />
    <Table style="font-size:20px" :content="self" border stripe :columns="columns1" :data="data1">
      <template slot-scope="{ row, index }" slot="action">
        <Button
          style="background: red;border-color: red;"
          type="error"
          v-if="row.isDefault=='否'"
          size="small"
          @click="modal1 = true;dataIndex=index;amend(row.id)"
        >修改</Button>
        <Button
          style="background: red;border-color: red;margin-left:10px"
          type="error"
          v-if="row.isDefault=='否'"
          size="small"
          @click="jurisdiction=true;configJurisdiction(data1[index]);dataIndex=index"
        >权限</Button>
        <Button
          style="background: red;border-color: red;margin-left:10px"
          type="error"
          v-if="row.isDefault=='否'"
          size="small"
          @click="Delete=true;dataIndex=index"
        >删除</Button>
      </template>
      <template slot-scope="{ row, index }" slot="forbid">
        <Button
          style="background: red;border-color: red;margin-left:10px"
          type="error"
          v-if="row.isDefault=='否'&&row.state=='正常'"
          size="small"
          @click="forbid(row)"
        >禁用</Button>
        <Button
          style="background: green;border-color: green;margin-left:10px"
          type="error"
          v-if="row.isDefault=='否'&&row.state=='禁用'"
          size="small"
          @click="open(row)"
        >启用</Button>
      </template>
    </Table>
    <Modal v-model="jurisdiction" title="修改权限" @on-ok="SaveJurisdiction(data1[dataIndex])">
      <Tree ref="tree" :data="treeData" show-checkbox></Tree>
    </Modal>

    <Modal v-model="Delete" title="删除角色" @on-ok="deleteUser(data1[dataIndex])">
      <div style="width:100%;text-align: center">是否删除角色！</div>
    </Modal>
    <Modal width="40" v-model="modal1" title="修改角色信息" @on-ok="ok(data1[dataIndex])">
      角色名称：
      <Input v-model="data1[dataIndex].name" style="width: auto;margin-right:15px" />描述：
      <Input v-model="data1[dataIndex].description" style="width: 370px;margin-right:15px" />
    </Modal>
    <Modal width="40" v-model="AddUser" title="添加角色" @on-ok="Add()">
      角色名称：
      <Input v-model="name" style="width: auto;margin-right:15px" />描述：
      <Input v-model="description" style="width: 370px;margin-right:15px" />
    </Modal>
    <Page style="margin-top:10px" :total="total" @on-change="pagingSuery" show-elevator />
    <Button
      style="background: #2d8cf0;border-color: #2d8cf0;float: right;padding: 8px 30px;font-size: 20px"
      type="error"
      size="small"
      @click="AddUser = true;name='';description=''"
    >添加角色</Button>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      treeData: [],
      dataIndex: 0,
      self: this,
      total: 0,
      AddUser: false,
      jurisdiction: false,
      description: "",
      name: "",
      Delete: false,
      modal1: false,
      keyword: "",
      pageNow: 0,
      types: [
        {
          value: "0",
          label: "禁用"
        },
        {
          value: "1",
          label: "正常"
        }
      ],
      state: "",
      columns1: [
        {
          title: "角色名称",
          align: "center",
          key: "name"
        },
        {
          title: "状态",
          key: "address",
          align: "center",
          slot: "forbid"
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime"
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime"
        },
        {
          title: "是否系统默认角色",
          align: "center",
          key: "isDefault"
        },
        {
          title: "描述",
          align: "center",
          key: "description"
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "action"
        }
      ],
      data1: [{}]
    };
  },
  mounted: function() {
    this.getData();
  },
  activated: function() {},

  methods: {
    configJurisdiction(row) {
      api.PermissionListTree(row.id).then(data => {
        this.formatting(data.body.data, "1");
        this.treeData = data.body.data;
      });
    },
    amend(id) {
      api.RoleGet(id).then(res => {
        this.data1[this.dataIndex] = res.body.data;
        this.$forceUpdate();
      });
    },
    SaveJurisdiction(row) {
      let res = this.$refs.tree.getCheckedNodes();
      //选择子节点添加父节点id
      let pmsIdList = [];
      this.treeData.forEach(element => {
        if (element.children) {
          element.children.forEach(elementC => {
            res.forEach(elementr => {
              if (elementr.id == elementC.id) {
                pmsIdList.push(element.id);
              }
            });
          });
        }
      });
      res.forEach(element => {
        pmsIdList.push(element.id);
      });

      pmsIdList = Array.from(new Set(pmsIdList));
      api
        .RoleAddPms({
          id: row.id,
          pmsIdList
        })
        .then(data => {
          this.$layer.alert(res.body.message);
          this.getData();
        });
    },
    formatting(data, index) {
      data.forEach(element => {
        if (element.child) {
          element.children = element.child;
          this.formatting(element.children, "2");
        }
        if (index != "1") {
          element.checked = element.selected;
        }

        element.title = element.name;
      });
    },
    Add() {
      api
        .RoleAdd({ name: this.name, description: this.description })
        .then(data => {
          this.getData();
        });
    },
    ok(row) {
      api
        .RoleEdit({ id: row.id, name: row.name, description: row.description })
        .then(data => {
          this.getData();
        });
    },
    deleteUser(row) {
      api.RoleDel(row.id).then(data => {
        this.getData();
      });
    },
    forbid(row) {
      api.RoleDisable(row.id).then(data => {
        this.getData();
      });
    },
    open(row) {
      api.RoleEnable(row.id).then(data => {
        this.getData();
      });
    },

    getData() {
      api
        .RoleList({
          pageNow: this.pageNow,
          pageSize: "10",
          state: this.state,
          keyword: this.keyword
        })
        .then(res => {
          this.total = res.body.data.total;
          this.data1 = res.body.data.list;
          this.data1.forEach(element => {
            if (element.state === 0) {
              element.state = "禁用";
            } else {
              element.state = "正常";
            }
            if (element.isDefault === 0) {
              element.isDefault = "否";
            } else {
              element.isDefault = "是";
            }
          });
        });
    },
    changeInput() {
          this.pageNow = 0;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    }
  }
};

</script>

<style scoped lang = 'less' >
#home {
  height: 100%;
}
</style>